//external link warnings
$(document).ready(function() {
    $('a[href="https://dandyworldwide.com/apps/redo/returns-portal"]').each(function() {
      var $a    = $(this);
      var text  =  $a.text().trim();
      $a.attr(
        'aria-label',
        text + ' (opens in a new window)'
      );
    });
  });


// // Add aria-label
// $(document).ready(function() {
//   $('a.text-with-icon.group').each(function() {
//     var $link = $(this);
//     var $reversedSpan = $link.find('.reversed-link');

//     // Look for the nearest heading before this link in the DOM
//     var headingText = $link.closest('section, div').find('h1, h2, h3, h4, h5, h6').first().text().trim();

//     if ($reversedSpan.length && headingText !== '') {
//       $reversedSpan.attr('aria-label', 'view all, ' + headingText);
//     }
//   });
// });


// Add aria-label
$(document).ready(function() {
  $('section-header').each(function() {
    var $link = $(this);
    var $reversedSpan = $link.find('a.text-with-icon.group');

    // Look for the nearest heading before this link in the DOM
    var headingText = $link.closest('section, div').find('h1, h2, h3, h4, h5, h6').first().text().trim();

    if ($reversedSpan.length && headingText !== '') {
      $reversedSpan.attr('aria-label', 'view all, ' + headingText);
    }
  });
});



// Iframe title
$(document).ready(function() {
  $('iframe:not([title])').each(function() {
    var $iframe = $(this);
    var src = $iframe.attr('src') || '';

    // Match by common sources
    if (src.includes('youtube.com') || src.includes('youtu.be')) {
      $iframe.attr('title', 'YouTube video');
    } else if (src.includes('vimeo.com')) {
      $iframe.attr('title', 'Vimeo video');
    } else if (src.includes('maps.google.com') || src.includes('google.com/maps')) {
      $iframe.attr('title', 'Google Map');
    } else if (src.includes('player.soundcloud.com')) {
      $iframe.attr('title', 'SoundCloud audio player');
    } else if (src.includes('facebook.com')) {
      $iframe.attr('title', 'Facebook embedded content');
    } else {
      $iframe.attr('title', 'Embedded content');
    }
  });
});



// Menu Drawer Focus
let drawerLastFocusedElement = null;

function toggleDrawer(open = true) {
  const drawerButton = document.querySelector('[aria-controls="navigation-drawer-1"]');
  const drawer = document.querySelector('.panel__wrapper');
  const focusableElements = drawer.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

  if (open) {
    // Store reference to the shop button
    drawerLastFocusedElement = document.activeElement;

    // Focus first focusable element
    if (focusableElements.length > 0) {
      setTimeout(() => focusableElements[0].focus(), 50);
    }

    // Add event listeners
    document.addEventListener('keydown', handleDrawerKeys);
  } else {
    
    // Restore focus
    if (drawerLastFocusedElement) {
      drawerLastFocusedElement.focus();
    }

    // Remove listeners
    document.removeEventListener('keydown', handleDrawerKeys);
  }
}

function handleDrawerKeys(event) {
  const drawer = document.querySelector('.panel__wrapper');
  const focusableElements = drawer.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  
  if (!drawer || drawer.style.display !== 'block') return;

  // Escape key
  if (event.key === 'Escape') {
    toggleDrawer(false);
    event.preventDefault();
    return;
  }

  // Tab key
  if (event.key === 'Tab') {
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus();
        event.preventDefault();
      }
    } else {
      if (document.activeElement === lastElement) {
        firstElement.focus();
        event.preventDefault();
      }
    }
  }
}

// Update your shop button (add click handler)
document.querySelector('[aria-controls="navigation-drawer-1"]').addEventListener('click', function() {
  const isExpanded = this.getAttribute('aria-expanded') === 'true';
  toggleDrawer(!isExpanded);
});

// Add click outside handler
document.querySelector('.panel__wrapper').addEventListener('click', function(e) {
  if (e.target === this) {
    toggleDrawer(false);
  }
});


//Mobile Menu
$('#mobile-nav').on('click', function() {
  setTimeout(function() {
    $('#header-sidebar-menu').attr('tabindex','-1').focus();
  }, 1000); // 1 second delay
});


// mobile navigation focus
$(document).ready(function() {
    $('#header-sidebar-menu').on('click', 'button', function () {
        var clickedButton = $(this);
        var clickedText = clickedButton.text().trim().toLowerCase(); // convert to lowercase
    
        setTimeout(function () {
            var matches = [];
            var clickedIndex = -1;
    
            // Find all buttons with the same text (case-insensitive) inside .panel-list__wrapper
            $('#header-sidebar-menu button').each(function () {
                var thisText = $(this).text().trim().toLowerCase(); // convert to lowercase for comparison
                if (thisText === clickedText) {
                    matches.push(this);
                    if (this === clickedButton[0]) {
                        clickedIndex = matches.length - 1;
                    }
                }
            });
    
            // If there are multiple matches, move focus to the next one
            if (matches.length > 1) {
                var nextIndex = (clickedIndex + 1) % matches.length;
                $(matches[nextIndex]).focus();
            }
        }, 500);
    });
});



// Product gallery
 $(document).ready(function() {
  $('.product-gallery__media.snap-center').each(function() {
    var $media = $(this);
    setInterval(() => {
   if ($media.hasClass('is-selected')) {
      $media.attr('aria-hidden', 'false');
    } else {
      $media.attr('aria-hidden', 'true');
    }
}, 1000);
   
  });
});



// Add to Cart popup
;(function($){
  var DRAWER = document.querySelector('cart-notification-drawer');
  var $drawer = $(DRAWER);
  var lastTrigger = null;

  function getFocusable($container) {
    return $container.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(':visible');
  }

  // Open drawer handler
  $(document).on('click', 'button[is="custom-button"]', function(){
    lastTrigger = this;
    var observer = new MutationObserver(function(muts, obs){
      if (DRAWER.hasAttribute('open')) {
        obs.disconnect();
        setTimeout(function(){
          var $items = getFocusable($drawer);
          if ($items.length) $items.first().focus();
        }, 100);

        // Focus trap
        $drawer.on('keydown.drawerTrap', function(e){
          if (e.key !== 'Tab') return;
          var $items = getFocusable($drawer);
          var first = $items.first()[0], last = $items.last()[0];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
          }
          else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        });

        // ESC handler
        $drawer.on('keydown.drawerClose', function(e){
          if (e.key === 'Escape') closeDrawer();
        });

        // Click outside handler
        $(document).on('mousedown.drawerClickOutside', function(e){
          if (!$(e.target).closest('cart-notification-drawer').length) {
            e.preventDefault();
            closeDrawer();
          }
        });
      }
    });
    observer.observe(DRAWER, { attributes: true });
  });

  // Close drawer function
  function closeDrawer(){
    DRAWER.removeAttribute('open');
    $drawer.off('.drawerTrap .drawerClose');
    $(document).off('mousedown.drawerClickOutside');

    // Return focus after animation
    setTimeout(function() {
      if (lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus();
      }
      lastTrigger = null;
    }, 50); // Match animation duration
  }

  // Updated close button handler for new close button
  $(document).on('click', '.quick-buy-drawer button[is="close-button"], .quick-buy-drawer .close-cursor', function(e) {
    e.preventDefault();
    closeDrawer();
  });

})(jQuery);


$('br').attr('aria-hidden', 'true');

